import { render } from "./Form.vue?vue&type=template&id=4d12e958&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=4d12e958&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d12e958"]])

export default __exports__